import { UCHI_DOMAIN } from 'shared/constants';

export const getUchiLoginRedirectUrl = (redirectUrl: string) =>
  `${UCHI_DOMAIN}/?next=${redirectUrl}`;
